module.exports = __webpack_public_path__ + "static/media/display-1.94f3c816.png";